import { createFileRoute } from '@tanstack/react-router';

import { getAgreementQueryOptions } from '@/_pages/agreements/api-service';

export const Route = createFileRoute('/_private/agreements/_template/$id/financial-override')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getAgreementQueryOptions(opts.params.id)),
  staticData: {
    // NOTE: This is a "virtual" permission route. It should NOT be added to `agreementsSubNav`.
    // It exists so User Roles can grant/revoke this permission independently.
    pageTitle: 'Financial Override',
    tabKey: 'agreement/financial-override',
  },
});
